export function monitoringSlots(api) {
  return {
    getMonitoringSlots(params) {
      return api.get('monitoring/slots', params).then(({ data }) => data)
    },
    exportMonitoringSlots(params) {
      return api.get('monitoring/slots/export', params, { responseType: 'blob' })
        .then(({ data }) => data)
    }
  }
}
